import { Avatar, Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';
import { Message } from './ChatConversation';
import AktifyChatIcon from './aktify-chat-icon.svg';

const ChatMessage = styled(Stack)`
  display: flex;
  align-items: center;
  min-width: 60%;
  max-width: 100%;
  gap: 8px;

  &.left {
    align-self: flex-start;
    flex-direction: row;
  }

  &.right {
    align-self: flex-end;
    flex-direction: row-reverse;
  }
`;

const ChatBubble = styled('div')<{
  sender: 'Inbound' | 'Outbound';
}>`
  border-radius: 10px;
  max-width: 80%;
  word-break: break-word;
  overflow-wrap: anywhere;
  padding: 10px;
  background-color: ${({ sender }) => (sender === 'Inbound' ? 'white' : '#318adc')};
  color: ${({ sender }) => (sender === 'Inbound' ? '#2e2e2e' : '#fff')};
`;

const AktifyIcon = styled(Box)(() => ({
  height: 40,
  width: 40,
  backgroundImage: `url(${AktifyChatIcon})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
}));

interface ChatMessageItemProps {
  message: Message;
}

export const ChatMessageItem: FC<ChatMessageItemProps> = ({ message }) => {
  const alignment = message.sender === 'Inbound' ? 'right' : 'left';

  return (
    <Stack spacing={0.5}>
      <ChatMessage className={alignment}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {alignment === 'right' ? (
            <Avatar sx={{ bgcolor: 'primary.main' }}>U</Avatar>
          ) : (
            <AktifyIcon />
          )}
        </Box>

        <ChatBubble sender={message.sender}>{message.text}</ChatBubble>
      </ChatMessage>

      <Box
        sx={{
          display: 'flex',
          justifyContent: alignment === 'left' ? 'flex-start' : 'flex-end',
          paddingLeft: alignment === 'left' ? '56px' : 0,
          paddingRight: alignment === 'right' ? '56px' : 0,
        }}
      >
        <Typography fontSize="0.75rem" color="gray">
          {new Date(message.time).toLocaleTimeString()}
        </Typography>
      </Box>
    </Stack>
  );
};
